import React,{useEffect} from "react";
import { useNavigate } from "react-router-dom";

export default function FortuneHub() {
  const navigate = useNavigate();

  useEffect(() => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "view_horoscope",
        category: "horoscope",
        label: "view_horoscope",
      });
    }, []);

  return (
    <div className="min-h-screen bg-[#0A0F28] text-white">
      {/* ======= Header: Back Button (ไม่ใช้ ProfileWithBackButtonHeader) ======= */}
      <header
        className="relative z-10"
        style={{
          position: "absolute",
          paddingTop:
            "calc(env(safe-area-inset-top, 0px) + 10px)" /* เผื่อ notch iPhone */,
        }}
      >
        <div className="px-4"></div>

        <div className="w-full h-20 px-5 xs:px-2 py-2 flex flex-col justify-end">
          <div className="w-full flex justify-between items-center">
            <div>
              <button
                aria-label="ย้อนกลับ"
                onClick={() => navigate("/")}
                className="inline-flex items-center justify-center w-9 h-9 rounded-2xl
                       bg-white/10 hover:bg-white/15 active:bg-white/20
                       shadow-[0_4px_14px_rgba(0,0,0,0.35)] backdrop-blur-[2px]
                       focus:outline-none focus:ring-2 focus:ring-white/30"
              >
                {/* Chevron Left (SVG) */}
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M15 19L8 12L15 5"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            </div>
            <div>{/*right*/}</div>
          </div>
        </div>
      </header>

      {/* ======= Hero (รูปการ์ด + Title + Subtitle) ======= */}
      <section className="px-5 pt-1">
        {/* รูปการ์ด: วางกึ่งกลาง และมีเงา */}
        <div className="w-full flex justify-center mt-2">
          <img
            src="/images/AW-Logo-Horoscope_03 2.png"
            alt="Fortune cards"
            width="202px"
            className="object-contain drop-shadow-[0_10px_28px_rgba(0,0,0,0.45)]"
          />
        </div>

        <div className="text-center">
          <h1 className="text-[26px] leading-8 font-extrabold tracking-tight">
            มหาลัคนาพลัส
          </h1>
          <p className="text-sm text-white/70 mt-1">
            ปลดล็อกความลับแห่งจักรวาล
          </p>
        </div>
      </section>

      {/* ======= Cards ======= */}
      <main className="px-8 mt-5 space-y-4 pb-10">
        {/* ไพ่ทาโรต์ */}
        <section
          className="
        relative rounded-[24px] px-10 py-6
        bg-[#2F1F58]  /* ม่วงเข้มด้านในให้ใกล้ภาพ */
        border border-white/70
        shadow-[0_10px_24px_rgba(0,0,0,0.45)]
        text-white
        overflow-hidden
      "
          style={{
            /* ขอบขาวนวลแบบในภาพ (ขาวอมเทา) */
            boxShadow:
              "0 12px 28px rgba(0,0,0,.35), inset 0 0 0 1px rgba(255,255,255,.3)",
            background: "linear-gradient(180deg,#3A2A73 0%, #2F1F58 100%)", // ไล่เฉดม่วง
          }}
        >
          {/* เส้นโค้งขาวของกรอบให้ดู “ฟุ้ง” แบบภาพ */}
          <div className="absolute inset-0 rounded-[24px] pointer-events-none ring-1 ring-white/60" />

          {/* ไอคอนการ์ดโปร่งซ้อน (SVG) */}
          <div className="absolute pl-[20px] top-5 opacity-90">
            {/*<div className="rounded-2xl bg-white/10 backdrop-blur-[2px] flex items-center justify-center">*/}
            <img
              src="/images/Cards.png"
              alt="Fortune cards"
              width="80px"
              className="object-contain drop-shadow-[0_10px_28px_rgba(0,0,0,0.45)]"
            />
            {/*</div>*/}
          </div>

          {/* เนื้อหา */}
          <div className="pl-[125px] pr-1 mt-1 text-left">
            <h3 className="text-[24px] leading-7 font-extrabold text-[#FFD15A]">
              ไพ่ทาโรต์
            </h3>
            <p className="mt-1 text-[14px] leading-[20px] text-[#FFD15A]">
              ดูดวงรายวัน
              <br />
              เปิดเผยความลับแห่งอนาคต
            </p>
          </div>
          <div className="pl-[5px] pr-1 mt-1">
            {/* ปุ่มทองไล่เฉดทรงแคปซูล */}
            <button
              onClick={() => navigate("/horoscope/tarot")}
              className="
            mt-5 w-full max-w-full h-[44px]
            rounded-full font-extrabold text-[16px]
            text-[#1B1300]
            shadow-[0_8px_22px_rgba(240,170,40,0.35)]
            active:translate-y-[1px]
          "
              style={{
                background:
                  "linear-gradient(90deg, #FFD86E 0%, #EAAE2C 45%, #CF7B00 100%)",
              }}
            >
              เริ่มดูไพ่ทาโรต์
            </button>
          </div>
        </section>

        {/* ลัคนาราศี */}
        <section
          className="
        relative rounded-[24px] px-10 py-6
         bg-[#40352A]
        border border-white/70
        shadow-[0_12px_28px_rgba(0,0,0,0.45)]
        text-white
        overflow-hidden
      "
          style={{
            /* ขอบขาวนวลแบบในภาพ (ขาวอมเทา) */
            boxShadow:
              "0 12px 28px rgba(0,0,0,.35), inset 0 0 0 1px rgba(255,255,255,.3)",
            background: "linear-gradient(180deg,#362E27 0%, #40352A 100%)", // ไล่เฉดม่วง
          }}
        >
          {/* เส้นโค้งขาวของกรอบให้ดู “ฟุ้ง” แบบภาพ */}
          <div className="absolute inset-0 rounded-[24px] pointer-events-none ring-1 ring-white/60" />

          {/* ไอคอนการ์ดโปร่งซ้อน (SVG) */}
          <div className="absolute pl-[20px] top-5 opacity-90">
            {/*<div className="rounded-2xl bg-white/10 backdrop-blur-[2px] flex items-center justify-center">*/}
            <img
              src="/images/Magic-Crystal-Ball.png"
              alt="Fortune cards"
              width="80px"
              className="object-contain drop-shadow-[0_10px_28px_rgba(0,0,0,0.45)]"
            />
            {/*</div>*/}
          </div>

          {/* เนื้อหา */}
          <div className="pl-[125px] pr-1 mt-1 text-left">
            <h3 className="text-[24px] font-extrabold text-[#FFD15A]">
              ลัคนาราศี
            </h3>
            <p className="mt-1 text-[14px] leading-[20px] text-[#FFD15A]">
              ดูดวงรายสัปดาห์
              <br />
              ลัคนาส่วนบุคคล
            </p>
          </div>
          <div className="pl-[5px] pr-1 mt-1">
            {/* ปุ่มทองไล่เฉดทรงแคปซูล */}
            <button
              onClick={() => navigate("/horoscope/ascendant")}
              className="
            mt-5 w-full max-w-full h-[44px]
            rounded-full font-extrabold text-[16px]
            text-[#1B1300]
            shadow-[0_8px_22px_rgba(240,170,40,0.35)]
            active:translate-y-[1px]
          "
              style={{
                background:
                  "linear-gradient(90deg, #FFD86E 0%, #EAAE2C 45%, #CF7B00 100%)",
              }}
            >
              เริ่มดูดวงรายสัปดาห์
            </button>
          </div>
        </section>

        {/* ชื่อมงคล */}
        <section
          className="
        relative rounded-[24px] px-10 py-6
         bg-[#0F4A49]
        border border-white/70 shadow-[0_12px_28px_rgba(0,0,0,0.45)]
        text-white
        overflow-hidden
      "
          style={{
            /* ขอบขาวนวลแบบในภาพ (ขาวอมเทา) */
            boxShadow:
              "0 12px 28px rgba(0,0,0,.35), inset 0 0 0 1px rgba(255,255,255,.3)",
            background: "linear-gradient(180deg,#0B3636 0%, #0F4A49 100%)", // ไล่เฉดม่วง
          }}
        >
          {/* เส้นโค้งขาวของกรอบให้ดู “ฟุ้ง” แบบภาพ */}
          <div className="absolute inset-0 rounded-[24px] pointer-events-none ring-1 ring-white/60" />

          {/* ไอคอนการ์ดโปร่งซ้อน (SVG) */}
          <div className="absolute pl-[20px] top-5 opacity-90">
            {/* <div className="rounded-2xl bg-white/10 backdrop-blur-[2px] flex items-center justify-center">*/}
            <img
              src="/images/Note.png"
              alt="Fortune cards"
              width="80px"
              className="object-contain drop-shadow-[0_10px_28px_rgba(0,0,0,0.45)]"
            />
            {/*  </div>*/}
          </div>

          {/* เนื้อหา */}
          <div className="pl-[125px] pr-1 mt-2 text-left">
            <h3 className="text-[24px] leading-7 font-extrabold text-[#FFD15A]">
              ชื่อมงคล
            </h3>
            <p className="mt-1 text-[14px] leading-[20px] text-[#FFD15A]">
              เช็คความเป็นมงคลของชื่อ
              <br />
              <br />
            </p>
          </div>
          <div className="pl-[5px] pr-1">
            {/* ปุ่มทองไล่เฉดทรงแคปซูล */}
            <button
              onClick={() => navigate("/horoscope/lucky-name")}
              className="
            mt-5 w-full max-w-full h-[44px]
            rounded-full font-extrabold text-[16px]
            text-[#1B1300]
            shadow-[0_8px_22px_rgba(240,170,40,0.35)]
            active:translate-y-[1px]
          "
              style={{
                background:
                  "linear-gradient(90deg, #FFD86E 0%, #EAAE2C 45%, #CF7B00 100%)",
              }}
            >
              เริ่มวิเคราะห์ชื่อมงคล
            </button>
          </div>
        </section>
      </main>
    </div>
  );
}
